import { useEffect, useState } from "react";

/* One listener per distinct query, shared by every component that asks it.
 * Six ServiceItems used to register six identical resize listeners and six
 * pieces of state for the same `>= 1024px` question.
 *
 * Starts at `initial` (default false) so the prerender pass and the first
 * client frame agree; the effect corrects it before paint. */
export function useMediaQuery(query, initial = false) {
  const [matches, setMatches] = useState(initial);

  useEffect(() => {
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const onChange = (e) => setMatches(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, [query]);

  return matches;
}

export default useMediaQuery;
